// src/redux/store.js
import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import apiReducer from "./api.Reducer"; // your API reducer
import rootSaga from "./rootSaga";      // root saga
import { WebSocketdataReducer } from "../Websocket/webSoketReducer";

// 1. Create saga middleware
const sagaMiddleware = createSagaMiddleware();

// 2. Combine all reducers (if you have more later, just add here)
const rootReducer = combineReducers({
  api: apiReducer,
  WebSocket:WebSocketdataReducer
});

// 3. Enable Redux DevTools Extension
//const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const composeEnhancers =
  process.env.NODE_ENV !== "production" &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: false,
        maxAge: 25 // ⬅ VERY IMPORTANT
      })
    : compose;


// 4. Create the store with middleware
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);

// 5. Run the root saga
sagaMiddleware.run(rootSaga);

export default store;
